export default {
  s: '%d second',
  smicro: '%ds',
  smid: '%d sec',

  ss: '%d seconds',
  ssmicro: '%ds',
  ssmid: '%d sec',

  m: '%d minute',
  mmicro: '%dm',
  mmid: '%d min',

  mm: '%d minutes',
  mmmicro: '%dm',
  mmmid: '%d min',

  h: '%d hour',
  hmicro: '%dh',
  hmid: '%d hour',

  hh: '%d hours',
  hhmicro: '%dh',
  hhmid: '%d hours',

  d: '%d day',
  dmicro: '%dd',
  dmid: '%d day',

  dd: '%d days',
  ddmicro: '%dd',
  ddmid: '%d days',
};
